<template>
  <span class="text">
    <span v-if="text.length === 0">&nbsp;</span>
    <template v-else v-for="part in text">
      <span v-if="typeof part === 'string'">{{part}}</span>
      <text-ref v-else :id="part.ref" :text="part.text"/>
    </template>
  </span>
</template>
<script>
  export default {
    name: 'TextWithRefs',
    components: {TextRef: () => import('./TextRef')},
    props: {
      text: {type: Array, required: true}
    }
  }
</script>
